import { render } from "./FooterContent.vue?vue&type=template&id=6bf04165&scoped=true"
import script from "./FooterContent.vue?vue&type=script&lang=js"
export * from "./FooterContent.vue?vue&type=script&lang=js"

import "./FooterContent.vue?vue&type=style&index=0&id=6bf04165&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf04165"]])

export default __exports__